

import { Checkbox, Box, Button, Card, CardContent, CardHeader, Menu, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, alpha, styled, IconButton, ListItemText, Skeleton, Chip, SelectChangeEvent, FormControl, InputLabel, FormHelperText, ToggleButton, ToggleButtonGroup, TablePagination, TableFooter, Avatar, Tooltip } from "@mui/material";
import SplitButton from '../splitbutton';
import { SplitMenuItem, DataOutput, DataField, DropdownModel, DataRow, NLCInfo, EditorType, FilterAttribute, DataAttribute } from "../../data/interfaces/sharedmodels";
import { Edit, Delete } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import {
    updateFilterAtts as updateMagneticFilterAtts, updateEditorType
} from "../../stores/magneticslice";
import {
    updateFilterAtts as updateItsoFilterAtts
} from "../../stores/itsoslice";

import { useCallback, useContext, useEffect, useState } from "react";
import magneticService from "../../data/api/magnetic.service";
import { showsuccessmessage, showerrormessage } from "../../stores/notificationslice";
import ConfirmDialog from "../confirmdialog";
import TablePaginationActions from "../tablepaginationactions";
import MasterListDialog from "../../modules/masterlist/childcomponents/masterlistdialog";
import { batch } from "react-redux";
import DataTableHeader from "../childcomponents/datatableheader";
import { formatValueAsReadOnly, formatValue, formatValueForApi } from "../commonfunctions";
import { MenuProps } from "../commonprops";
import MergeGroupField from "./mergegroupfield";
import EditableField from "./editabledatatablefield";
import { IsEditedContext } from "../../../App";





const EditableDataTable = ({ data, parent, callback, versions }:
    { data: DataOutput, parent: string, callback: any, versions: DropdownModel[] }) => {

    const dispatch = useAppDispatch();
    const [currentData, setCurrentData] = useState<DataOutput>(data);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [needConfirmComments, setNeedConfirmComments] = useState<boolean>(true);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isMasterListOpen, setIsMasterListOpen] = useState<boolean>(false);
    const [selectedMasterList, setSelectedMasterList] = useState<DropdownModel>({ Id: '0', Description: '' });
    const [currentMasterListCodes, setCurrentMasterListCodes] = useState<string[]>([]);
    const [findNreplaceItems, setFindNreplaceItems] = useState([]);
    const [deletedRows, setDeletedRows] = useState<number[]>([]);
    const [maxLengthAtt,setMaxLengthAtt]=useState<{ [key: string]: DataAttribute }>({});
    const { setIsEdited } = useContext(IsEditedContext) ;
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const editorType = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.editorType; }
        else { return state.itsoReducer.editorType; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const [modifiedData, setModifedData] = useState<DataOutput>({
        ReadOnlyUser: true,
        Fields: data.Fields, Rows: [], CanDeleteRows: data.CanDeleteRows, IsEditable: true,
        FieldLookups: data.FieldLookups, CanAddRows: data.CanAddRows, TableId: data.TableId, Version: data.Version
    });
    useEffect(() => {
        setCurrentData(data);
        setModifedData({
            ReadOnlyUser: true,
            Fields: data.Fields, Rows: [], CanDeleteRows: data.CanDeleteRows,
            FieldLookups: data.FieldLookups, CanAddRows: data.CanAddRows,
            TableId: selectedTable?.Id ?? 0, Version: data.Version, IsEditable: true
        })
        setDeletedRows([]);
        setPage(0);
        if(data&&data.Rows)
            setMaxLengthAtt(getMaxAttributeLengthByValue(data.Rows.flatMap(a=>a.Attributes).filter(a=>a.Value!=null||a.Value!=undefined)));
    }, [data]);

    const getMaxAttributeLengthByValue = (array: DataAttribute[]) => {
        return array.reduce((acc, att) => {
            const { Name, Value } = att;
            
            if (!acc[Name] || Value.length > acc[Name].Value.length) {
                acc[Name] = att;
            }
            
            return acc;
        }, {} as { [key: string]: DataAttribute });
    }; 

    const handleValueChange = useCallback((field: DataField, uniqueId: any, newValue: any) => {
        setIsEdited(true);
        if (modifiedData.Rows.findIndex(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId) > -1) {
            let existData = { ...modifiedData };
            existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].Attributes.filter(a => a.Name == field.Name)[0].Value = newValue;
            if(existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].OldUniqueId==null){
            existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].OldUniqueId=existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].UniqueIdValue;
            }
            setModifedData(existData);
        }
        else {
            const row = currentData.Rows.filter(a => a.UniqueIdValue == uniqueId)[0];
            const newRow = { ...row };
            newRow.Attributes.filter(a => a.Name == field.Name)[0].Value = formatValueForApi(newValue, field.Type, field.IsNullable);
            newRow.OldUniqueId = newRow.UniqueIdValue;
            newRow.UniqueIdValue = null;
            let existData = { ...modifiedData };
            existData.TableId = selectedTable?.Id ?? 0;
            existData.Rows.push(newRow);
            setModifedData(existData);
        }
    }, [currentData]);

    function findDuplicateGroups(data: DataOutput) {
        // Get all unique field names
        const uniqueFieldNames = data.Fields.filter(field => field.IsUnique);
        const groupedRows: Record<string, DataRow[]> = {};
        if(uniqueFieldNames.length<1){
            return groupedRows;
        }
        

        data.Rows.filter(a=>a.IsDeleted==false).forEach(row => {
            // Create a composite key by joining all unique field values
            const key = uniqueFieldNames
                .map(field => {
                    let attribute = {...row.Attributes.find(attr => attr.Name === field.Name)};
                    const lookUps=data.FieldLookups.filter(a=>a.FieldName==field.Name);
                    if(lookUps&&lookUps.length&& attribute){
                        attribute.Value=lookUps[0].LookUpValues.find(a=>a.Id==attribute?.Value)?.Description;
                    }
                    return attribute ? String(attribute.Value) : "undefined";
                })
                .join("|"); // Use a separator to ensure uniqueness
    
            if (!groupedRows[key]) {
                groupedRows[key] = [];
            }
            groupedRows[key].push(row);
        });
    
        // Keep only groups where more than one row exists
        const duplicateGroups = Object.fromEntries(
            Object.entries(groupedRows).filter(([_, rows]) => rows.length > 1)
        );

        return duplicateGroups;
    }
      
      

    const handleSaveClick = () => {
        const duplicates=findDuplicateGroups(currentData);
        if(Object.keys(duplicates).length>0){
            dispatch(showerrormessage(`Duplicates entry value found on ${Object.keys(duplicates).join(', ')}`));
            return;
        }
        let tempModifiedData = { ...modifiedData };
        if (tempModifiedData.Rows && tempModifiedData.Rows.length < 1) {
            dispatch(showerrormessage("There is No data has changed.."));
            return;
        }
        
        tempModifiedData.Rows.forEach(row => {
            if (row.UniqueIdValue && !row.OldUniqueId&&!row.IsDeleted) { 
                row.UniqueIdValue = null;
            }
        });
       

        
    
        tempModifiedData.Version = selectedVersion ?? "";
        const updateInput = { NlcId: !selectedTable?.IsGlobal&& selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: tempModifiedData };
        magneticService.updateTableData(updateInput).then((response) => {
            if (response && response.data) {
                dispatch(showsuccessmessage("The data is saved successfully."))
                setIsEdited(false);
                callback();
            }else{
                tempModifiedData = { ...modifiedData };
                return;
            }
        });
    }


    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Confirm change of current version to ' + selectedVersion + '?');
        setNeedConfirmComments(true);
        setDialogOpen(true);
    }



    const confirmDialogCallback = useCallback((confirmed: boolean, remarks: string, type: string) => {
        setDialogOpen(false);

        if (type == "Set Version") {
            if (confirmed) {
               
                    magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks, selectedNlcs.length ? selectedNlcs[0].Id : null).then((response) => {
                    if (response.data.IsSuccess) {
                        dispatch(showsuccessmessage(response.data.Message));
                        callback();
                    }
                    else {
                        dispatch(showerrormessage(response.data.Message))
                    }

                });
                
            }
        }
        else if (type == "Delete") {
           
            if (confirmed) {
                let tempData = { ...modifiedData }
                let tempCurrentData = { ...currentData }
                for (let index = 0; index < deletedRows.length; index++) {
                    var tempRow=currentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]];
                    if((tempRow.UniqueIdValue==null||tempRow.UniqueIdValue<1)&&(tempRow.OldUniqueId==null||tempRow.OldUniqueId<1))
                    {
                        tempData.Rows.splice(tempData.Rows.findIndex(a=>a.UniqueIdValue==tempRow.UniqueIdValue&&a.OldUniqueId==tempRow.OldUniqueId),1);
                        tempCurrentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]].IsDeleted = true;
                    }
                    else{
                    tempData.Rows.push(currentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]]);
                    tempCurrentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]].OldUniqueId=
                    tempCurrentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]].UniqueIdValue;
                    tempCurrentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]].IsDeleted = true;
                    }
                    
                }
                setModifedData(tempData);
                setCurrentData(tempCurrentData);
                setIsEdited(true);
            }
            setDeletedRows([])

        }
    }, [selectedTable, selectedVersion, deletedRows, modifiedData])


   
    
    const generateUniqueId = () => {
        return Math.floor(Math.random() * 1000000000)*-1; 
    };
    
    
  
    const addRow = () => {
        let tempData = { ...currentData };
        let tempRow: DataRow = { Attributes: [], UniqueIdValue: generateUniqueId(), OldUniqueId: null, IsDeleted: false };
        tempData.Fields.forEach(field => {
            tempRow.Attributes.push({ Name: field.Name, Value: field.IsMultiSelect ? [] :
                 !field.IsNullable&&currentData.FieldLookups.findIndex(a => a.FieldName == field.Name) > -1?
                  currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues[0].Id:
                  formatValueForApi(field.Min, field.Type, field.IsNullable) })
        });
        tempData.Rows.push(tempRow);
        let tempModifiedData = { ...modifiedData };
        tempModifiedData.Rows.push(tempRow);
        setModifedData(tempModifiedData);
        setCurrentData(tempData);
        setIsEdited(true);
        let lastPage = Math.ceil(tempData.Rows.length / rowsPerPage);
        if (page != lastPage)
            setPage(lastPage - 1);
    }

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - currentData.Rows.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const showMasterList = (masterList: DropdownModel | null) => {
        if (masterList != null) {
            let field = currentData.Fields.filter(a => a.MasterList != null && a.MasterList.Id == masterList.Id)[0];
            let excludedCodes: string[] = [];
            currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues.forEach((item) => {
                excludedCodes.push(item.Id)

            })
            setCurrentMasterListCodes(excludedCodes);
            setSelectedMasterList(masterList);
            setIsMasterListOpen(true);
        }
    }

    const addNewMasterListItems = (items: DropdownModel[]) => {
        setIsMasterListOpen(false);
        if (items.length > 0) {
            let field = currentData.Fields.filter(a => selectedMasterList != null && a.MasterList?.Id == selectedMasterList.Id)[0];
            let fieldLookup = currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0];
            let newLookupvalues = fieldLookup.LookUpValues.concat(items);
            let tempData = { ...currentData };
            tempData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues = newLookupvalues;
            setCurrentData(tempData);
            setIsEdited(true);
        }
    }

    const editRow = (row: DataRow) => {
        let filterFields: FilterAttribute[] = [];
        currentData.Fields.filter(a => a.IsFilterField).forEach(field1 => {

            filterFields.push({ Name: field1.Name, Value: row.Attributes.filter(f => f.Name == field1.Name)[0].Value, DataType: field1.DataType })
        });
        if (parent === 'magnetic') {
            batch(() => {
                dispatch(updateMagneticFilterAtts(filterFields));
                dispatch(updateEditorType(EditorType.Form));
            });

        }
        else {
            batch(() => {
                dispatch(updateItsoFilterAtts(filterFields));
                dispatch(updateEditorType(EditorType.Form));
            });
        }

    }

    const deleteRow = (index: number) => {
        let tempDeletedRows = [...deletedRows];
        tempDeletedRows.push(index);
        setDeletedRows(tempDeletedRows);
        setDialogTitle('Delete');
        setDialogMessage('Confirm deletion of selected row?');
        setNeedConfirmComments(false);
        setDialogOpen(true);
    }

    const findAndReplace = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let tempData = { ...currentData };
        currentData.Fields.filter(a => a.CanFindAndReplace).forEach(field => {

            tempData.Rows.forEach((row) => {
                for (let i = 0; i < (field.FindAndReplaceOptionCount ?? 1); i++) {
                    let oldVal = data.get(field.Name + '_oldVal_' + i);
                    let newVal = data.get(field.Name + '_newVal_' + i);
                    if (oldVal && newVal && (oldVal != newVal)) {
                        let att = row.Attributes.filter(a => a.Name == field.Name && a.Value == oldVal);
                        if (att && att.length > 0) {
                            att[0].Value = newVal;
                        }
                    }
                }
            })
        });
        setCurrentData(tempData);
        dispatch(showsuccessmessage('Values changed successfully.'))


    }
    const mergedGroupsHeaders = new Set();
    const mergedGroups = new Set();

    const getMaxPossibleRows=()=> {
        let filterFieldLookups= currentData.FieldLookups.filter(a=>currentData.Fields.filter(b=>b.IsFilterField)
        .findIndex(c=>c.Name==a.FieldName)>-1);
        if(filterFieldLookups.length<1)return 99999;
        return filterFieldLookups.reduce((total, item) => total * item.LookUpValues.length, 1);
        
    }

    return (
        <Box component='div'>
            {currentData.IsEditable && currentData.Rows && currentData.Rows.length > 0 && currentData.Fields.findIndex(a => a.CanFindAndReplace) > -1 ?
                <Box component="form" onSubmit={findAndReplace} sx={{ p: 2, mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        Find and Replace
                    </Typography>
                    {currentData.Fields.filter(a => a.CanFindAndReplace).map((canffield) => {
                        let distinctValues = [...new Set(currentData.Rows.filter(a => a.UniqueIdValue).flatMap(r => r.Attributes.filter(b => b.Name == canffield.Name)[0].Value.toString()))];
                        let count = distinctValues.length < (canffield.FindAndReplaceOptionCount ?? 1) ? distinctValues.length : (canffield.FindAndReplaceOptionCount ?? 1);
                        let fieldCounter = Array.from(Array(count ?? 0).keys());
                        return (
                            fieldCounter.map((fCounter) => {
                                return (
                                    <Box key={'freplace'+fCounter} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography sx={{ width: '100%' }}>{canffield.Description + ' Set ' + (fCounter + 1)} </Typography>
                                        <Select
                                            size="small"
                                            name={canffield.Name + '_oldVal_' + fCounter}
                                            value={distinctValues[fCounter]}

                                            sx={{ width: '100%' }}>

                                            {
                                                distinctValues.map((ditem) => {
                                                    return (
                                                        <MenuItem key={ditem} value={ditem}>{ditem}</MenuItem>
                                                    )
                                                })}


                                        </Select>
                                        <TextField type="number" name={canffield.Name + '_newVal_' + fCounter} sx={{ width: '100%', ml: 1, mr: 1 }} size="small"></TextField>
                                    </Box>
                                )
                            })

                        )
                    }

                    )
                    }
                    
                    <Button type="submit" variant="outlined">Replace</Button>
                </Box> : null}
          
            <TableContainer  sx={{maxHeight:670}}>
                {currentData.Fields && currentData.Fields.length > 0 && currentData.Rows ?
                    <Table sx={{ minWidth: 650 }} stickyHeader size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>

                                {

                                    currentData.Fields.filter(a => a.IsBrowsable).map((field) => {
                                        let attField = currentData.Fields.filter(a => a.Name == field.Name)[0];
                                        if (attField.MergeGroup != null && !mergedGroupsHeaders.has(attField.MergeGroup)) {

                                            mergedGroupsHeaders.add(attField.MergeGroup);
                                            return (
                                                <TableCell
                                                    sx={{ minWidth: '400px' }}
                                                   
                                                    key={field.Name}
                                                >
                                                    {field.MergeGroup ?? field.Name}
                                                   
                                                    {field.MasterList != null && currentData.IsEditable ? <Button sx={{ m: 1, ml: 2 }} variant="outlined" onClick={() => showMasterList(field.MasterList)}>Add</Button> : null}
                                                </TableCell>
                                            );
                                        } else if (attField.MergeGroup != null && mergedGroupsHeaders.has(attField.MergeGroup)) {

                                            return null;
                                        } else {
                                            return (

                                                <TableCell width={maxLengthAtt[field.Name]&&data.Fields&&data.Fields.length>5?maxLengthAtt[field.Name].Value.toString().length*12:'100%' } sx={{ minWidth: '120px'}}  key={field.Name}>   {field.Description ?? field.Name}
                                                    {field.MasterList != null && currentData.IsEditable ? <Button sx={{ m: 1, ml: 2 }} variant="outlined" onClick={() => showMasterList(field.MasterList)}>Add</Button> : null}</TableCell>

                                            )
                                        }

                                    })

                                }

                                {selectedTable?.EditorType == EditorType.TableOrForm ? <TableCell >Edit</TableCell> : null}
                                {selectedTable?.CanDeleteRows ? <TableCell width={1} >Delete</TableCell> : null}

                            </TableRow>
                            <TableRow >

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {/* <TableCell padding="checkbox">

                            </TableCell> */}
                            {(rowsPerPage > 0
                                ? currentData.Rows.filter(a => !a.IsDeleted).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : currentData.Rows.filter(a => !a.IsDeleted)).map((row, index) => {
                                    return (

                                        <TableRow
                                            key={'row_'+index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >

                                            {
                                                currentData.Fields.filter(a => a.IsBrowsable).map((field) => {
                                                    let attField = currentData.Fields.filter(a => a.Name == field.Name)[0];
                                                    if (attField.ToggleField && row.Attributes.filter(a => a.Name == attField.ToggleField)[0].Value == attField.ToggleCondition) {

                                                        return (<TableCell key={field.Name + row.UniqueIdValue} sx={{ textAlign: 'center' }}>-</TableCell>)
                                                    }
                                                    else if (attField.MergeGroup != null) {

                                                        let mergedFields = currentData.Fields.filter(f => f.MergeGroup === attField.MergeGroup);
                                                        let values = mergedFields.map(f => row.Attributes.find(a => a.Name === f.Name));

                                                        if (field === mergedFields[0]) {

                                                            return (
                                                                <TableCell key={field.Name + row.UniqueIdValue}>
                                                                    <MergeGroupField title={field.MergeGroup} mergeFields={mergedFields} values={values || []} key={field.Name + row.UniqueIdValue} uniqueIdValue={row.UniqueIdValue} callback={handleValueChange} ></MergeGroupField>
                                                                </TableCell>
                                                            );
                                                        } else {

                                                            return null;
                                                        }
                                                    }
                                                    else {
                                                        return (
                                                            <Tooltip title={field.ToolTip} key={field.Name+row.UniqueIdValue}>
                                                                <TableCell >
                                                                    <EditableField width={maxLengthAtt[field.Name]&&data.Fields&&data.Fields.length>5?maxLengthAtt[field.Name].Value.toString().length*12:999} isEditable={currentData.IsEditable} key={field.Name + row.UniqueIdValue} field={field} value={row.Attributes.filter(a => a.Name == field.Name)[0].Value}
                                                                        uniqueId={row.UniqueIdValue} callback={handleValueChange}
                                                                        fieldLookups={currentData.FieldLookups.findIndex(a => a.FieldName == field.Name) > -1 ?
                                                                            currentData.FieldLookups[currentData.FieldLookups.findIndex(a => a.FieldName == field.Name)].LookUpValues : undefined} /></TableCell></Tooltip>
                                                        )
                                                    }
                                                })
                                            }
                                            {selectedTable?.EditorType == EditorType.TableOrForm && currentData.IsEditable ? <TableCell><IconButton onClick={() => editRow(row)}><Edit /></IconButton></TableCell> : null}
                                            {(selectedTable?.MinRowCount == null || currentData.Rows.filter(a => !a.IsDeleted).length > selectedTable?.MinRowCount) && selectedTable?.CanDeleteRows && currentData.IsEditable ? <TableCell width={1} align="center"><IconButton onClick={() => deleteRow(index)}><Delete /></IconButton></TableCell> : null}

                                        </TableRow>
                                    )
                                })
                            }
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow >
                                <TablePagination
                                sx={{"& .MuiTablePagination-spacer": {
                                order: 2
                                }}}
                                    rowsPerPageOptions={[10,20,30, 40, 50, { label: 'All', value: -1 }]}
                                    count={currentData.Rows.filter(a => !a.IsDeleted).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    showFirstButton={true}
                                    showLastButton={true}
                                    SelectProps={{
                                        inputProps: {
                                            'aria-label': 'rows per page'

                                        }
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>}


            </TableContainer>
            {currentData.Fields && currentData.Fields.length > 0 && currentData.Rows ?
            <Box sx={{ display: 'flex', justifyContent: 'space-between',mt:2 }}>
                <Box>
                                        {(selectedTable?.MaxRowCount == null || currentData.Rows.filter(a => !a.IsDeleted).length < selectedTable?.MaxRowCount) &&
                                        currentData.Rows.filter(a => !a.IsDeleted).length < getMaxPossibleRows()&&
                                        currentData.CanAddRows && currentData.IsEditable ? <Button variant="outlined" onClick={addRow} sx={{mr:1}}>Add More</Button> : null}
                                        {!currentData.ReadOnlyUser && versions.findIndex(a => a.Id == selectedVersion && a.Description.includes('active')) < 0 && currentData.Rows.length > 0 ? <Button variant="outlined" onClick={handleSetCurrent}>Set Current Version</Button> : null}
                                        </Box>
                                            {currentData && currentData.IsEditable ? <Button sx={{ mr: 2 }}  variant="contained" onClick={handleSaveClick}>Save</Button> : null}
                                            
                                       

                                    </Box>:null}
            <ConfirmDialog minCommentChar={10} needComments={needConfirmComments} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={confirmDialogCallback} />
            <MasterListDialog isopen={isMasterListOpen} listType={selectedMasterList}
                excludedCodes={currentMasterListCodes} callback={addNewMasterListItems} />
        </Box>
    )
}

export default function EditableDataList({ heading, data, parent, versions, callback }:
    { heading: string | undefined, data: DataOutput, parent: string, versions: DropdownModel[], callback: any }) {

    return (
        <Card>
            <CardHeader sx={{pb:0}}  title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent sx={{pt:0}}>
                {heading == undefined ? '' : <EditableDataTable data={data} parent={parent} callback={callback} versions={versions} />}
            </CardContent>
        </Card>
    );
}